(ns frontend.ui.component.lp-portal.tabbed-card.view
  (:require
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [reagent.core :as r]
   [herb.core :refer [<class <id]]
   [frontend.ui.component.lp-portal.tabbed-card.style :as style]))

(defn tabbed-card
  [{:keys [selected]} children]
  (let [selected (r/atom selected)
        switch-tab #(reset! selected %)]
    (fn []
      [:div
       {:class (<class style/default-padding)}
       (into [:div
              {:class (<class style/title-line)}]
             (map (fn [{:keys [id title]}]
                    [:span
                     {:class    (<class style/title (= id @selected))
                      :on-click #(switch-tab id)}
                     title])
                  children))
       [card {:id (<id style/card)}
        (->> children
             (filter #(= (:id %) @selected))
             first
             :body)]])))
